import axios from "axios";
import { apiWrapWithErrorWithData, headersProvider } from "../apiHelpers";
import constants from "../constants";

// Process document for chat
// export const processDocument = async ({signedUrl, agreementId}) => {
//   const response = await fetch(`${constants.apiHost}/api/chat-ai/process-document`, {
//     method: "POST",
//     headers: headersProvider(),
//     body: JSON.stringify({ signed_url: signedUrl, agreement_id: agreementId })
//   });

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.detail || 'API error');
//   }

//   return response.json();
// };

export const processDocument = async ({ signedUrl, agreementId }) => {
  return axios.post(
    `${constants.apiHost}/api/chat-ai/process-document`,
    { signed_url: signedUrl, agreement_id: agreementId },
    {
      headers: {
        ...headersProvider(),
      },
    },
  );
};

export const getDocumentStatus = async (taskId) => {
  return axios.get(
    `${constants.apiHost}/api/chat-ai/document-status/${taskId}`,
    {
      headers: {
        ...headersProvider(),
      },
    },
  );
};
// Get document processing status
// export const getDocumentStatus = async (taskId) => {
//   const response = await fetch(`${constants.apiHost}/api/chat-ai/document-status/${taskId}`);

//   if (!response.ok) {
//     throw new Error('Failed to get document processing status');
//   }

//   return response.json();
// };

// Send query to chat
// export const sendQuery = async (question, queryId, k = 3) => {
//   const response = await fetch(`${constants.apiHost}/api/chat-ai/query`, {
//     method: "POST",
//     headers: headersProvider(),
//     body: JSON.stringify({
//       question,
//       query_id: queryId,
//       k
//     })
//   });

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.detail || 'API error');
//   }

//   return response.json();
// };

export const sendQuery = async (question, queryId, k = 3) => {
  return axios.post(
    `${constants.apiHost}/api/chat-ai/query`,
    { question: question, query_id: queryId, k: k },
    {
      headers: {
        ...headersProvider(),
      },
    },
  );
};
// Get query status
export const getQueryStatus = async (taskId) => {
  const response = await fetch(
    `${constants.apiHost}/api/chat-ai/query-status/${taskId}`,
    { headers: headersProvider() },
  );

  if (!response.ok) {
    throw new Error("Failed to get task status");
  }

  return response.json();
};

// Process document generating conversation id
export const processConversation = async ({
  signedUrl,
  agreementId,
  fileExtension,
  fileName,
}) => {
  return axios.post(
    `${constants.apiHost}/api/chat-ai/conversation`,
    {
      signed_url: signedUrl,
      agreement_id: agreementId,
      file_extension: fileExtension,
      file_name: fileName,
    },
    {
      headers: {
        ...headersProvider(),
      },
    },
  );
};

// Process multiple documents generating conversation id for multi-doc chat
export const processConversationMultidoc = async ({
  signedUrls,
  agreementIds,
  fileExtensions,
  fileNames,
}) => {
  return axios.post(
    `${constants.apiHost}/api/chat-ai/conversation-multidoc`,
    {
      signed_urls: signedUrls,
      agreement_ids: agreementIds,
      file_extensions: fileExtensions,
      file_names: fileNames,
    },
    {
      headers: {
        ...headersProvider(),
      },
    },
  );
};

// Process new answers using the as the hook conversation id
// Supports both single and multi-document chat via agreement_ids parameter
export const processAnswer = async ({
  question,
  conversationID,
  agreementIds = null,
}) => {
  const payload = {
    question: question,
    conversation_id: conversationID,
  };

  // Include agreement_ids if provided (for multi-doc or single-doc with document references)
  if (agreementIds && agreementIds.length > 0) {
    payload.agreement_ids = agreementIds;
  }

  return axios.post(`${constants.apiHost}/api/chat-ai/ans`, payload, {
    headers: {
      ...headersProvider(),
    },
  });
};

// Process new answers using streaming API
// Supports both single and multi-document chat via agreementIds parameter
export const processAnswerStream = async ({
  question,
  conversationID,
  agreementIds = null,
}) => {
  const payload = {
    question,
    conversation_id: conversationID,
  };

  // Include agreement_ids if provided (for multi-doc or single-doc with document references)
  if (agreementIds && agreementIds.length > 0) {
    payload.agreement_ids = agreementIds;
  }

  const response = await fetch(`${constants.apiHost}/api/chat-ai/ans/stream`, {
    method: "POST",
    headers: {
      ...headersProvider(),
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify(payload),
  });

  // Debug: Check response headers
  //
  // for (let [key, value] of response.headers.entries()) {
  //
  // }
  //

  if (!response.ok) {
    throw new Error(`HTTP error status: ${response.status}`);
  }

  return response;
};
